import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function Layout({ children }: { children: React.ReactNode }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const jePromatrac = user?.role === 'promatrac';

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <>
      <nav className="navbar navbar-dark bg-primary">
        <div className="container-fluid">
          <span className="navbar-brand">
            Sustav narudžbenica
            {jePromatrac && (
              <small className="text-white-50"> | SVE NARUDŽBENICE (Samo pregled)</small>
            )}
            {user?.odjel_naziv && !jePromatrac && (
              <small className="text-white-50">
                {' '}
                | {user.odjel_naziv} ({user.odjel_sifra})
              </small>
            )}
          </span>
          <div className="text-white d-flex align-items-center gap-2">
            <span>{user?.ime} {user?.prezime}</span>
            {jePromatrac && <span className="badge bg-info">Promatrač</span>}
            {user?.role === 'administrator' && (
              <Link to="/firme" className="btn btn-sm btn-light">
                Firme
              </Link>
            )}
            <button onClick={handleLogout} className="btn btn-sm btn-light">
              Odjava
            </button>
          </div>
        </div>
      </nav>
      <div className="container-fluid mt-4">{children}</div>
    </>
  );
}
